import DateNav from '../vue/DateNav.vue'
import { createApp } from "vue";
import { i18n } from '../i18n';

/**
 * @param {string | Element} mountPoint
 * @param {object} props
 * @param {number} props.activeCompanyID
 * @param {Date} props.startDate
 * @param {Date} props.endDate
 * @param {string} props.timePeriodType
 * @param {string} props.currentPage
 * @param {string} [props.page]
 * @param {boolean} [props.showDailyButton]
 * @param {boolean} [props.showFilterButton]
 * @param {boolean} [props.filterButtonActive]
 * @param {boolean} [props.hideDateRangeWhenSmall]
 * @param {boolean} [props.showMargin]
 * @param {boolean} [props.forceMobileSelector]
 * @param {boolean} [props.hidePeriodSelector]
 * @param {boolean} [props.showCalendarButton]
 * @param {boolean} [props.customViewShowsRange]
 * @param {boolean} [props.showYearButton]
 */
export function mountDateNavComponent(mountPoint, props) {
  const app = createApp(DateNav, props);
  app.use(i18n);
  app.mount(mountPoint);
}